import script from "./CategorySymbolsCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategorySymbolsCollapse.vue?vue&type=script&setup=true&lang=ts"

import "./CategorySymbolsCollapse.vue?vue&type=style&index=0&id=5e142317&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e142317"]])

export default __exports__